__turbopack_context__.v({
  "card": "DownloadAppQrModal-module-scss-module__oaFrha__card",
  "closeBtn": "DownloadAppQrModal-module-scss-module__oaFrha__closeBtn",
  "content": "DownloadAppQrModal-module-scss-module__oaFrha__content",
  "dialog": "DownloadAppQrModal-module-scss-module__oaFrha__dialog",
  "overlay": "DownloadAppQrModal-module-scss-module__oaFrha__overlay",
  "title": "DownloadAppQrModal-module-scss-module__oaFrha__title",
});
